import {get, post} from "../api"
import * as url from "../url"
import {format} from "react-string-format";

const apiGetInvoiceDetail = data => {
  return get(format(url.API_INVOICE_DETAIL, data.sign) + "detail/", data.history)
}

const apiGetInvoiceSelect = data => {
  return get(url.API_INVOICE + "detail-select/" + data.section_id + "/" + data.supplier_crn + "/", data.history)
}

const apiPostInvoiceUpdate = data => {
  return post(format(url.API_INVOICE_DETAIL, data.sign) + "update/", data.history, data.data)
}

export {
  apiGetInvoiceDetail,
  apiGetInvoiceSelect,
  apiPostInvoiceUpdate,
}
